import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string) => (
    <path
        d="M11 7.33333V11M18.3333 9.31796C18.3333 15.3389 13.7793 18.0382 11.8486 18.9121L11.8462 18.9132C11.6432 19.0051 11.5414 19.0512 11.3106 19.0908C11.1645 19.1158 10.8364 19.1158 10.6903 19.0908C10.4586 19.051 10.3558 19.0048 10.1511 18.9121C8.22049 18.0382 3.66667 15.3389 3.66667 9.31795V5.68351C3.66667 4.65675 3.66667 4.14299 3.86649 3.75081C4.04226 3.40585 4.32252 3.12559 4.66749 2.94982C5.05966 2.75 5.57342 2.75 6.60018 2.75H15.4002C16.4269 2.75 16.9396 2.75 17.3318 2.94982C17.6767 3.12559 17.9579 3.40585 18.1337 3.75081C18.3333 4.1426 18.3333 4.65574 18.3333 5.6805V9.31796ZM11.0457 13.75V13.8417L10.9544 13.8418V13.75H11.0457Z"
        stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
)

export const ShieldWarning: React.FC<IconProps> = ({color, size, ...props}) => (
    <IconWrapper {...{...props, size, color}} renderIcon={renderIcon}
                 viewBox={`0 0 ${parseInt(size)} ${parseInt(size)}`}/>
)
